import _extends from "@babel/runtime-corejs3/helpers/extends";
import React from 'react';
import Vega from './Vega';
/**
 * Syntactic sugar for using vega-lite with Vega
 * @param props
 */

export default function VegaLite(props) {
  return React.createElement(Vega, _extends({}, props, {
    mode: "vega-lite"
  }));
}